import { SectionWrapper } from '../components/SectionWrapper';
import { SubjectPill } from '../components/SubjectPill';

import styles from './SubjectsSection.module.css';

const subjects = [
  'Physics',
  'Astronomy',
  'Chemistry',
  'History',
  'Economics',
  'Biology',
  'Calculus',
  'Statistics',
  'Psychology',
  'Sociology',
  'US Government',
  'Anatomy & Physiology',
] as const;

export function SubjectsSection() {
  return (
    <SectionWrapper background="white" data-testid="faculty-section-subjects" id="subjects">
      <div className={styles.section}>
        <div className={styles.columns}>
          <div className={styles.left}>
            <p className={styles.eyebrow}>SUBJECTS</p>
            <h2 className={styles.title}>Find your subject.</h2>
            <p className={styles.bodyLarge}>
              Kudu has a deep catalog of pre-built courses, with strongest
              coverage in STEM subjects with the highest enrollments. We&apos;re
              an official partner of OpenStax — every OpenStax subject is
              supported.
            </p>
          </div>

          <div className={styles.right}>
            <p className={styles.count}>30+ SUBJECTS</p>
            <p className={styles.body}>
              Biology, Calculus, Statistics, Sociology, Psychology, Political
              Science, Anatomy &amp; Physiology, Chemistry, College Algebra, US
              Government, Economics, and more — every OpenStax subject is
              supported on Kudu, with original Kudu content beyond it too.
            </p>
            <div aria-label="Featured subjects" className={styles.pills}>
              {subjects.map((subject) => (
                <SubjectPill key={subject} label={subject} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
